<script>
import {mapState, mapActions} from 'vuex';
import AllocationFilters from '../AllocationFilters/AllocationFilters.vue';
import AllocationList from '../AllocationList/AllocationList.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import store from '../../store';

export default {
    components: {
        AllocationFilters,
        AllocationList,
        InfoWidget
    },
    computed: {
        ...mapState({
            tips: state => state.allocation.allocationPage.tips,
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) => {
            store.dispatch('allocation/getAccommodationList', supplier.id);
        }
    },
    created () {
        this.getAccommodationList(this.supplier.id);
    },
    methods: {
        ...mapActions({
            getAccommodationList: 'allocation/getAccommodationList',
            getSuppliers: 'nav/getSuppliers'
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$refs.infoWidget.clean();
        next();
    },
}
</script>
<template>
    <div class="allocation-page">
        <allocation-filters/>
        <allocation-list/>
        <info-widget ref="infoWidget" :tips="tips"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AllocationPage/AllocationPage.vue